import { render, staticRenderFns } from "./firststatisticsdetail.vue?vue&type=template&id=02d573b2&scoped=true&"
import script from "./firststatisticsdetail.vue?vue&type=script&lang=js&"
export * from "./firststatisticsdetail.vue?vue&type=script&lang=js&"
import style0 from "./firststatisticsdetail.vue?vue&type=style&index=0&id=02d573b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d573b2",
  null
  
)

export default component.exports